import React, { useState } from "react";

export default function ConfirmModal({ message, onConfirm, onCancel, type = "confirm" }) {
    const [inputData, setInputData] = useState("");

    return (
        <div className="modal--backdrop modal--confirm">
            <div className="modal d-block" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content rounded-5">
                        <div className="modal-header me-1 ms-1">
                            <h5 className="modal-title">Підтвердження</h5>
                            <button type="button" className="btn-close" onClick={onCancel}></button>
                        </div>
                        <div className="modal-body ms-1 me-1">
                            {
                                (type === "input" ? (
                                    <>
                                        <p className="m-0">{message}</p>
                                        <input
                                            type="text"
                                            className="w-100 form-control rounded-5"
                                            value={inputData}
                                            onChange={(e) => setInputData(e.target.value)}
                                            required
                                        />
                                    </>
                                ) : (
                                    <p className="m-0">{message}</p>
                                ))
                            }
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-dark rounded-5" onClick={onCancel}>
                                Скасувати
                            </button>
                            <button
                                className="btn main--button ps-4 pe-4"
                                onClick={() => {
                                    onConfirm(inputData);
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
